import {
  GuaranteesApprovalLetterExecutionCheck,
  type TGuaranteesApplication,
} from '~/store/guarantees/types.ts';

const normalizeExecutionCheckValue = (
  value: unknown
): GuaranteesApprovalLetterExecutionCheck | null => {
  const normalizedValue = String(value ?? '').trim().toUpperCase();

  if (normalizedValue === GuaranteesApprovalLetterExecutionCheck.PAPER) {
    return GuaranteesApprovalLetterExecutionCheck.PAPER;
  }

  if (normalizedValue === GuaranteesApprovalLetterExecutionCheck.ELECTRONIC) {
    return GuaranteesApprovalLetterExecutionCheck.ELECTRONIC;
  }

  return null;
};

export const getGuaranteesApprovalLetterExecutionCheck = (
  application?: TGuaranteesApplication | null
): GuaranteesApprovalLetterExecutionCheck => {
  const nestedApplicationForm = normalizeExecutionCheckValue(
    application?.executionChecks?.applicationForm
  );

  if (nestedApplicationForm) {
    return nestedApplicationForm;
  }

  const nestedExecutionCheck = normalizeExecutionCheckValue(
    application?.executionChecks?.executionCheck
  );

  if (nestedExecutionCheck) {
    return nestedExecutionCheck;
  }

  return (
    normalizeExecutionCheckValue(application?.executionCheck) ??
    GuaranteesApprovalLetterExecutionCheck.ELECTRONIC
  );
};

export const isGuaranteesApprovalLetterPaperExecutionCheck = (
  application?: TGuaranteesApplication | null
): boolean =>
  getGuaranteesApprovalLetterExecutionCheck(application) ===
  GuaranteesApprovalLetterExecutionCheck.PAPER;

export const isGuaranteesApprovalLetterElectronicExecutionCheck = (
  application?: TGuaranteesApplication | null
): boolean =>
  getGuaranteesApprovalLetterExecutionCheck(application) ===
  GuaranteesApprovalLetterExecutionCheck.ELECTRONIC;
